import { create } from 'zustand';

export type GameMode = 'free' | 'paid' | 'createRoom' | 'joinRoom';

interface GameModeState {
  selectedGameMode: GameMode;
  setSelectedGameMode: (mode: GameMode) => void;
}

export const useGameModeStore = create<GameModeState>((set) => ({
  selectedGameMode: 'free',
  setSelectedGameMode: (mode) => {
    set({ selectedGameMode: mode });
  }
}));
